import { render, staticRenderFns } from "./ListCartReminder.vue?vue&type=template&id=2537b1b7&"
import script from "./ListCartReminder.vue?vue&type=script&lang=js&"
export * from "./ListCartReminder.vue?vue&type=script&lang=js&"
import style0 from "./ListCartReminder.vue?vue&type=style&index=0&id=2537b1b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports